import React, { Component } from 'react';
import Tabs from '../../components/Tab';
import Staff from './Staff';

class Members extends Component {
    render () {
        const MembersTabList = [
             {
                 key: 'staff',
                 name: 'Staff',
                 path: '/staff',
                 content: <Staff />
             }
        ]
         return(
            <>
                <div className="main-header">
                    Members
				</div>
                <Tabs TabList={MembersTabList} />
            </>
         )
     }
    
 }
 
 export default Members;